

angular
.module('inkfinder')
.factory('Appointments', function Appointments(
  $http,
  $rootScope,
  ENDPOINT,
  FormatAppointment,
  FormatProject,
  Session,
  moment,
  AlertMessages,
  _
) {
  // Defaults
  Appointments.appointments = [];

  // Public methods
  Appointments.get = get;
  Appointments.detectAppointmentCollisions = detectAppointmentCollisions;

  /**
   * @name get
   * @description Function to get a collection of appointments. Supports
   * pagination from the endpoint.
   * @param {object} search The search criteria for paginated results.
   * @param {date} start The start datetime of search query
   * @param {date} end The end datetime of the search query
   * @param {number} timestamp A unix timestamp to use when checking the last
   * call to this endpoint.
   * @param {number} artist The artist ID to filter appointments by.
   * @param {number} collector The collector ID to filter appointments by.
   * @param {number} projectId The project ID to filter appointments by
   * @return {array} appointments Returns an array of appointments.
   */
  function get(search, start, end, timestamp, artist, collector, projectId) {
    let association_id = _.isUndefined(Session.activeState.association) ?
      '' : Session.activeState.association.id;
    let role = Session.activeState.role;
    let url = ENDPOINT.server + 'appointments/api/v1.1/?';
    url +=
      (association_id ? ('association_id=' + association_id) : '') +
      (timestamp ? ('&timestamp=' + timestamp) : '') +
      '&role=' + role;
    if (search !== false) {
      let _search = _.cloneDeep(search);
      // Determine if Status is 'All', then set status to false to not send
      // status to the endpoint
      if (search.status === 'All types of') {
        _search.status = undefined;
      }
      // Convert values to match the API.
      if (search.sort === 'Appointment date') {
        _search.sort = 'appointmentDatetime';
      }
      if (search.sort === 'Client last name') {
        _search.sort = 'collectorLastName';
      }
      url += '&page=' + _search.page + '&sort=' + _search.sort;
      url += '&page=' + _search.page + '&sort=' + _search.sort;
      if (_search.search !== '') {
        url += '&search=' + _search.search;
      }
      if (!_.isUndefined(_search.status)) {
        url += '&status=' + _search.status;
      }
    }
    if (!_.isUndefined(start) && !_.isUndefined(end)) {
      url +=
      '&start_datetime=' + start.format() +
      '&end_datetime=' + end.format();
    }
    if (!_.isUndefined(artist)) {
      url += '&artist_id=' + artist;
    }
    if (!_.isUndefined(collector)) {
      url += '&collector_id=' + collector;
    }
    if (!_.isUndefined(projectId)) {
      url += '&project_id=' + projectId;
    }
    return $http.get(url).then(function(response) {
      let collection;
      if (!_.isUndefined(response.data.results)) {
        collection = response.data;
        collection.results =
        FormatAppointment.formatCollection(response.data.results);
        return collection;
      }
      collection = FormatAppointment.formatCollection(response.data);
      return collection;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name detectAppointmentCollisions
   * @description unknown
   * @param {unknown} rule Unknown
   * @param {unknown} appointmentDayGroups Unknown
   * @param {unknown} allAppointments Unknown
   * @param {unknown} day Unknown
   * @return {unknown} Unknown
   */
  function detectAppointmentCollisions(
  rule,
  appointmentDayGroups,
  allAppointments,
  day) {
    let applicable_appointments = [];
    let daily_appointments = [];
    let range_appointments = [];
    let collision_count = 0;

    // Figure out the Applicable Days based on a Rule
    for (let i = 0; i < rule.selected_days.length; i++) {
      let day_index = rule.selected_days[i].id;

      if (appointmentDayGroups[day_index].length) {
        let appointments_by_day = appointmentDayGroups[day_index];
        for (let j = 0; j < appointments_by_day.length; j++) {
          applicable_appointments.push(appointments_by_day[j]);
        }
      }
    }

    // Process Applicable Appointments
    for (let n = 0; n < applicable_appointments.length; n++) {
      let appointment_start =
      moment(applicable_appointments[n]
      .appointment_datetime, 'YYYY-MM-DDTHH:mm:ss')
      .startOf('minutes');
      let appointment_end =
      moment(applicable_appointments[n]
      .appointment_datetime, 'YYYY-MM-DDTHH:mm:ss')
      .add(applicable_appointments[n].duration, 'minutes');

      let start_time;
      let end_time;

      if (rule.start_time) {
        start_time = rule.start_time;
      }
      if (rule.end_time) {
        end_time = rule.end_time;
      }

      if (rule.temp) {
        if (rule.temp.raw_start_time) {
          start_time = moment(rule.temp.raw_start_time);
        }
        if (rule.temp.raw_end_time) {
          end_time = moment(rule.temp.raw_end_time);
        }
      }

      // Date Correction
      if (end_time < start_time) {
        end_time.add(1, 'day');
      }

      if (!(start_time.unix() >= appointment_end.unix() || end_time.unix() <=
      appointment_start.unix())) {
        collision_count++;
      }

      // Day's Appointments Only
      if (appointment_start.unix() < moment(day).endOf('day').unix()) {
        daily_appointments.push(applicable_appointments[n]);
      }
    }

    // Process Current + Future Appointments
    for (let c = 0; c < allAppointments.length; c++) {
      let start =
      moment(allAppointments[c].appointment_datetime, 'YYYY-MM-DDTHH:mm:ss')
      .startOf('minutes');

      // If there's a Range
      if (rule.temp.raw_start_date && rule.temp.raw_end_date) {
        let range_start =
        moment(rule.temp.raw_start_date).startOf('day').unix();
        let range_end =
        moment(rule.temp.raw_end_date).endOf('day').unix();

        if (range_start <=
        moment(start).unix() && range_end >= moment(start).unix()) {
          range_appointments.push(allAppointments[c]);
        }
      }
    }
    return {
      appointment_collisions: collision_count,
      applicable_appointments: applicable_appointments,
      daily_appointments: daily_appointments,
      range_appointments: range_appointments
    };
  }

  /**
   * @name resetvariables
   * @description Reset variables
   */
  function reset() {
    Appointments.artistAppointments = {};
    Appointments.collectorAppointments = {};
    Appointments.appointment = {};
    Appointments.collector = {};
    Appointments.appointments = [];
    Appointments.currentAppointments = {};
  }

  // Called to Reset Data on Logout
  let deregister = $rootScope.$on('clear-data', function() {
    reset();
  });
  $rootScope.$on('$destroy', deregister);

  return Appointments;
});



// WEBPACK FOOTER //
// ./components/appointments/appointments.service.js